import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";

import { StyledHeader, HeaderRow, StyledLink } from "./style";
import Title from "../Title/Title";

const Header = () => {
  const { pathname } = useLocation();
  const onInfo = pathname === "/info";

  return (
    <StyledHeader>
      <div className="container">
        <HeaderRow>
          <StyledLink to="/">
            <Title weight={700}>STEVEN ROBERTS</Title>
          </StyledLink>

          {/* <StyledLink to={onInfo ? "/" : "/info"}>
            <Title weight={700}>{onInfo ? "WORK" : "INFO"}</Title>
          </StyledLink> */}
        </HeaderRow>
      </div>
    </StyledHeader>
  );
};

export default Header;